import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SubscribeSystemStringService {
  SystemString: SystemStrings = {
    Download: '',
    ReadMore: '',
    ViewAll: '',
    Email: '',
    Name: '',
    PreferredLanguage: '',
  };

  private details = new BehaviorSubject<SystemStrings>(this.SystemString);
  subscribeFormPlaceholder = this.details.asObservable();

  subscribeFormDetails(details: SystemStrings) {
    this.details.next(details);
  }
}
